export default __webpack_public_path__ + "static/media/m16.dcf91dff.svg";